<template>
    <div class="kt-portlet__body no-padding">
        <app-alert :type="'danger'" :icon="'glyphicons-exclamation-sign'" @handleClick="errors = []"
                   v-show="errors.length">
            <b>{{ $t('AppProfileChangePassword.Por favor, verifique os erros informados') }}</b>
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </app-alert>
        <div class="kt-form">
            <form class="kt-form kt-form--label-right" v-on:submit.prevent>
                <div class="kt-portlet__body shadow-lg bg-white pl-5 pr-5" style="border-radius: 10px;">
                    <div class="form-group row">
                        <div class="title col-12 p-1">
                            {{ $t('AppProfileChangePassword.Alterar Senha') }}
                            <img src="../../../../assets/icons/icone-trocar-senha.svg" alt=""
                                 class="mb-1 ml-1"
                                 width="20"
                                 height="20">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label> {{ $t('AppProfileChangePassword.Senha atual') }}</label>
                        <app-input class="col-12" v-model="old_password" type="password"/>
                    </div>
                    <div class="form-group row">
                        <label>{{ $t('AppProfileChangePassword.Nova senha') }} </label>
                        <app-input class="col-12" v-model="new_password" type="password"/>
                    </div>
                    <div class="form-group row">
                        <label>{{ $t('AppProfileChangePassword.Confirmar nova senha') }} </label>
                        <app-input class="col-12" v-model="new_password_verify" type="password"/>
                    </div>
                    <div class="form-group row">
                        <app-button class="mt-4 col-12 col-lg-3 ml-lg-auto btn-sucess" type="primary"
                                    @handleClick="validateForm">
                            <span class="pi pi-save mr-2"/>
                            {{ $t('AppProfileChangePassword.Salvar') }}
                        </app-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>


<script>
import AppButton from '../../../common/AppButton';
import AppInput from '../../../common/AppInput';
import AppAlert from '../../../common/AppAlert';

import axios from '../../../../axios/axios-auth';
import {router} from '@/router';

const MAX_PASSWORD_LENGTH = 64;
const MIN_PASSWORD_LENGTH = 8;
const SPECIAL_CHARACTERS = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
const LOWER_CASE = /[a-z]/;
const UPPER_CASE = /[A-Z]/;
export default {
    data() {
        return {
            old_password: null,
            new_password: null,
            new_password_verify: null,
            errors: []
        }
    },
    components: {
        AppButton, AppInput, AppAlert
    },
    methods: {
        back() {
            router.go(-1);
        },
        validateForm() {
            this.errors = [];
            if (!this.old_password) {
                this.errors.push(this.$t('AppProfileChangePassword.Informe a senha atual'));
            }

            if (!this.new_password) {
                this.errors.push(this.$t('AppProfileChangePassword.Informe a nova senha'));
            }
            if (this.new_password !== this.new_password_verify) {
                this.errors.push(this.$t('AppProfileChangePassword.A nova senha não confere'));
            }

            if (!this.isValidPassword()) {
                this.errors.push(this.$t('AppProfileChangePassword.A senha deve possuir entre 8 e 64 caracteres e ao menos um caracter maiúsculo, um minúsuclo e um caracter especial'));
            }

            if (this.errors.length === 0) {
                this.updatePassword();
            }
        },
        isValidPassword() {
            const hasRequiredLength = MIN_PASSWORD_LENGTH <= this.new_password.length && this.new_password.length <= MAX_PASSWORD_LENGTH;
            const hasSpecialCharacter = SPECIAL_CHARACTERS.test(this.new_password);
            const hasLowerCaseCharacter = LOWER_CASE.test(this.new_password);
            const hasUpperCaseCharacter = UPPER_CASE.test(this.new_password);

            return hasRequiredLength && hasSpecialCharacter && hasLowerCaseCharacter && hasUpperCaseCharacter;
        },
        updatePassword() {
            let vm = this;
            axios.post(process.env.VUE_APP_BACKEND_ADDRESS + '/auth/api/v1/me/update-password', {
                old_password: vm.old_password,
                new_password: vm.new_password
            }).then((response) => {
                if (response.status === 200) {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppProfileChangePassword.Senha atualizada'),
                        detail: this.$t('AppProfileChangePassword.A senha foi atualizada com sucesso'),
                        life: 3000
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppProfileChangePassword.Senha não atualizada'),
                            detail: this.$t('AppProfileChangePassword.A senha atual está incorreta'),
                            life: 3000
                        });
                    }
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppProfileChangePassword.Senha não atualizada'),
                        detail: this.$t('AppProfileChangePassword.Não foi possível trocar a senha'),
                        life: 3000
                    });
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
@import "../../../../assets/styles/constants";

.form-group {
    margin-bottom: 1rem;
}

label {
    margin-bottom: 0;
}

img {
    filter: $aside-menu-item-inactive;
}

.title {
    border-bottom: 0.5px rgb(219, 219, 219) solid;
    padding-bottom: 15px;
    font-weight: bold;
    text-align: center;
    padding-top: 8px;
    font-size: 14px;
}

.kt-form {
    width: 80%;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .kt-form {
        width: 95%;
    }
}

@media (max-width: 1024px) and (min-width: 768px) {
    .kt-form {
        width: 95%;
    }
}
</style>
